/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiToggleButtonGroup to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/toggle-button-group/#css
 */ export const MuiToggleButtonGroup = {
    defaultProps: {
        size: 'small',
        exclusive: true
    }
};

//# sourceMappingURL=togglebuttongroup-overrides.js.map